import ClassesSettingsPage from "@/account/ClassesSettingsPage";
import withSettingsDirectoryPrivileges from "@/account/withSettingsDirectoryPrivileges";
import NewselaGlobalLayout from "@/base";
import RootProviders from "@/base/RootProviders";

const SettingsClassesPageRoute = () => (
  <NewselaGlobalLayout mainContents={<ClassesSettingsPage />} />
);

export async function getServerSideProps(ctx) {
  const RootProvidersInitialProps = await RootProviders.__getInitialProps({
    ctx,
  });

  return {
    props: {
      [RootProviders.InitialPropsName]: RootProvidersInitialProps,
    },
  };
}

export default withSettingsDirectoryPrivileges(SettingsClassesPageRoute);
